theme.SlideShow = (function () {
  function Slider(e) {
    let sliderWrapper = e.querySelector(".hero__slider--activation"),
      slideLoop = e.dataset.slideLoop,
      slideAutoplay = e.dataset.slideAutoplay,
      autoplayDuration = e.dataset.autoplayDuration,
      slideLoopValue = true,
      autoplay = false,
      slideNavPrev = e.querySelector(".swiper-button-prev"),
      slideNavNext = e.querySelector(".swiper-button-next"),
      sliderPagination = e.querySelector(".swiper-pagination"),
      slideShowSpace = parseInt(e.dataset.slideshow)
        ? parseInt(e.dataset.slideshow)
        : 0,
      sliderPerView = parseInt(e.dataset.slidesperview)
        ? parseInt(e.dataset.slidesperview)
        : 1,
      smallDesktop = parseInt(e.dataset.samlldesktopview)
        ? parseInt(e.dataset.samlldesktopview)
        : 1,
      tabletShow = parseInt(e.dataset.showTablet)
        ? parseInt(e.dataset.showTablet)
        : 1,
      mobileShow = parseInt(e.dataset.showMobile)
        ? parseInt(e.dataset.showMobile)
        : 1;

    //console.log(sliderPerView);

    if (slideLoop == "false") {
      slideLoopValue = false;
    }
    if (slideAutoplay == "true") {
      let sliderDuration = parseInt(autoplayDuration);
      autoplay = { delay: autoplayDuration, disableOnInteraction: false };
    }

    var swiper = new Swiper(sliderWrapper, {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      autoplay: autoplay,
      loop: slideLoopValue,
      clickable: true,
      speed: 1000,
      spaceBetween: 0,
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },
      on: {
        init: function () {
          const active = sliderWrapper.querySelector(".swiper-slide-active img");
          if (active) {
            active.style.transform = "scale(1)";
            active.style.opacity = "1";
          }
        },
        transitionStart: function () {
          // Handles both normal and loop transitions
          const allSlides = sliderWrapper.querySelectorAll(".swiper-slide img");
          allSlides.forEach((img) => {
            img.style.transition = "transform 1.4s ease, opacity 1.4s ease";
          });

          const active = sliderWrapper.querySelector(".swiper-slide-active img");
          const next = sliderWrapper.querySelector(".swiper-slide-next img");

          // Current stays steady
          if (active) {
            active.style.transform = "scale(1)";
            active.style.opacity = "1";
          }

          // Upcoming starts zoomed-in and faint
          if (next) {
            next.style.transform = "scale(1.08)";
            next.style.opacity = "0.9";
          }
        },
        transitionEnd: function () {
          // Ensures final position is correct even on loop reset
          const allSlides = sliderWrapper.querySelectorAll(".swiper-slide img");
          allSlides.forEach((img) => {
            img.style.transform = "scale(1.08)";
            img.style.opacity = "0.9";
          });

          const active = sliderWrapper.querySelector(".swiper-slide-active img");
          if (active) {
            active.style.transform = "scale(1)";
            active.style.opacity = "1";
          }
        },
      },
    });

    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return Slider;
})();
